export const PAGE_CATEGORIES = [
  { title: "כללי", pages: ["HomePage", "PermissionsPage", "TimeLinePage"] },
  {
    title: "כספים ורכש",
    pages: ["PurchaseInvoicePage", "CheckInvoicesPage", "AproveLinesPage", "TradeDelayPage", "LibertyMedicalPage", "PurchaseOrderManagementPage"],
  },
  {
    title: "מכירות ושיווק",
    pages: ["SalesPromotionsPage", "PromotionsSystemPage", "AgentComplaintsPage"],
  },
  {
    title: "ייבוא ולוגיסטיקה",
    pages: ["ImportManagementPage", "emailTrackingPage", "QrCodeDeviceMappingPage", "ManagersDashboardPage", "CustomerPortalPage"],
  },
  { title: "משאבי אנוש ורפואי", pages: ["ChemoRecordsPage", "HRCVMatchingPage", "Form161Page"] },
  { title: "ציוד ותפעול", pages: ["EldanPrinterPage", "EldanAgentPage", "FuelControlPage", "DplStatisticsPage"] },
  { title: "מחקר והזדמנויות", pages: ["ResearchMonitorPage"] },
];

export const getActiveCategories = (role, pageNames) => {
  const categorized = new Set(PAGE_CATEGORIES.flatMap((c) => c.pages));
  const other = pageNames.filter((p) => !categorized.has(p) && p !== "ViewObligoData" && p !== "ResearchMonitorRole");
  const groups = other.length ? [...PAGE_CATEGORIES, { title: "אחר", pages: other }] : PAGE_CATEGORIES;

  return groups
    .map((g) => ({ title: g.title, count: g.pages.filter((p) => role?.[p] === true).length }))
    .filter((g) => g.count > 0)
    .sort((a, b) => b.count - a.count);
};
